import React, { useRef, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAppContext } from "../hooks/useAppContext";
import "./Breadcrumbs.scss";

function Breadcrumbs({ breadcrumbs, search }) {
  const { innerWidth } = useAppContext();

  useEffect(() => {
    if (breadcrumbs.length > 0) {
      const lastBreadcrumb = breadcrumbs[Object.keys(breadcrumbs).length - 1];
      if (lastBreadcrumb.type === "keyword") {
        breadcrumbs.pop();
      }

      if (search?.length > 0 && breadcrumbs.length > 0) {
        breadcrumbs.push({ name: search, type: "keyword" });
      }
    }
  }, [breadcrumbs, search]);

  const renderBreadcrumbs = () => {
    return breadcrumbs.map((breadcrumb, index) => {
      return index + 1 < breadcrumbs.length ? (
        <li key={breadcrumb.tid}>
          <Link
            to={breadcrumb.alias}
            state={{ catId: breadcrumb.tid }}
          >
            {innerWidth < 768 && breadcrumb.alias == "/give"
              ? "All Areas of Need"
              : breadcrumb.name}
          </Link>
        </li>
      ) : (
        // Current page in breadcrumb trail is not linked.
        <li key={breadcrumb.tid}>{breadcrumb.name}</li>
      );
    });
  };

  const bcRef = useRef();

  useEffect(() => {
    window.scroll({top:0,behavior:'smooth'});
  }, [bcRef]);

  return breadcrumbs.length > 1 ? (
    <ul
      id="breadcrumb"
      ref={bcRef}
      className="breadcrumbs coh-breadcrumb coh-style-breadcrumbs coh-style-breadcrumbs-light"
    >
      {renderBreadcrumbs()}
    </ul>
  ) : (
    <div
      id="breadcrumb"
      ref={bcRef}
      className="breadcrumbs coh-breadcrumb coh-style-breadcrumbs coh-style-breadcrumbs-light"
    >
      &nbsp;
    </div>
  );
}

export default Breadcrumbs;
